import classNames from 'classnames';
import { TaxcardStatusCodes } from '@Page/SalaryTaxCard/reducers/altinnHandling';
import { useIntl } from 'react-intl';

interface Status {
    readonly className: string;
    readonly text?: string;
    readonly description?: string;
}

export enum SpecialStatus {
    NOT_FETCHED = 'NOT_FETCHED',
    FETCHED = 'FETCHED',
}

const GREEN: Status = {
    className: 'GREEN',
};
const ORANGE: Status = {
    className: 'ORANGE',
};

const GREY: Status = {
    className: 'GREY',
};

const RED: Status = {
    className: 'RED',
};
//KGFIXME which color code should they map to
function mapToStatus(code: string | undefined, fetchedText: string, notFetchedText: string, unknownText: string) {
    switch (code) {
        case TaxcardStatusCodes.OK:
            return {
                ...GREEN,
                text: fetchedText,
            };
        case TaxcardStatusCodes.NO_DEDUCTION:
            return {
                ...GREY,
            };
        case TaxcardStatusCodes.NO_TAXCARD:
            return {
                ...GREY,
            };
        case TaxcardStatusCodes.INVALID_ORGNO:
            return {
                ...RED,
            };
        case TaxcardStatusCodes.INVALID_PERS_D_NUM:
            return {
                ...RED,
            };
        case SpecialStatus.NOT_FETCHED:
            return {
                ...ORANGE,
                text: notFetchedText,
            };
        case TaxcardStatusCodes.WORK_PERMIT_UNCLEAR:
            return {
                ...ORANGE,
            };
        case TaxcardStatusCodes.D_NUM_EXPIRED_PERS_NUM_OK:
            return {
                ...ORANGE,
            };
        case TaxcardStatusCodes.STATUS_MANUAL:
            return {
                ...ORANGE,
            };
        default:
            //doesnt have a status in the database (resultatPaaForesporsel is empty and card is not manual)
            return {
                ...ORANGE,
                text: unknownText,
            };
    }
}

export function StatusColumnComponent(
    status: string | undefined,
    statusDescription: string | undefined,
    skeleton?: boolean,
): JSX.Element {
    const intl = useIntl();
    const statusObj: Status = mapToStatus(
        status,
        intl.formatMessage({ id: 'text_fetched' }),
        intl.formatMessage({ id: 'text_not_fetched' }),
        intl.formatMessage({ id: 'text_unknown' }),
    );
    return (
        <span
            className={`taxCard_status-column taxcardOverview__tooltip ${skeleton ? 'taxCard-skeleton' : ''}`}
            aria-label={
                status != '' && status != SpecialStatus.NOT_FETCHED
                    ? `${intl.formatMessage({
                          id: 'text_altinn_errors_altinnkode',
                      })}:\n${
                          status ?? intl.formatMessage({ id: 'text_unknown' })
                      }${capitalizeFirstLetter(statusObj.description)}`
                    : undefined
            }
        >
            <span className={classNames('taxCard_status-column_dot', skeleton ? '' : statusObj.className)} />
            <span className="atl-text-base">{statusObj.text ?? capitalizeFirstLetter(statusDescription)}</span>
        </span>
    );
}

function capitalizeFirstLetter(string: string | undefined) {
    if (string == undefined) {
        return '';
    }

    return string.charAt(0).toUpperCase() + string.slice(1);
}
